var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconClock = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#525254",
  fillRule: "evenodd",
  d: "M0 10c0 5.52 4.47 10 9.99 10C15.52 20 20 15.52 20 10S15.52 0 9.99 0C4.47 0 0 4.48 0 10m10-8c4.42 0 8 3.58 8 8s-3.58 8-8 8-8-3.58-8-8 3.58-8 8-8m-.266 3A.73.73 0 0 0 9 5.731v5.07l.34.215 4.533 2.87a.735.735 0 0 0 1.012-.225.73.73 0 0 0-.225-1.009l-4.193-2.588V5.73A.73.73 0 0 0 9.734 5"
})));
export default SvgIconClock;